import React from "react";
import { View, StyleSheet, Dimensions } from "react-native";
import { ScrollView } from "react-native-gesture-handler";
import Modal from "react-native-modal";

import { Portal } from 'react-native-paper';

interface RightPanelProps {
  visible: boolean;
  onClose: () => void;
  children: React.ReactNode;
}

const RightPanel: React.FC<RightPanelProps> = ({ visible, onClose, children }) => {
  const screenWidth = Dimensions.get("window").width;
    //console.log("Screen Width:", screenWidth * 0.5);
  return (
    <Modal
      isVisible={visible}
      onBackdropPress={onClose}
      backdropOpacity={0.3}
      animationIn="slideInRight"
      animationOut="slideOutRight"
      style={styles.modal}
    >
      <Portal.Host>
        <ScrollView style={[styles.panel, { width: (screenWidth * 0.8) > 600 ? 600 : screenWidth * 0.5 }]}>
          {children}
        </ScrollView>
      </Portal.Host>
    </Modal>
  );
};

const styles = StyleSheet.create({
  modal: {
    margin: 0, // full screen
    //justifyContent: "flex-end",
    alignItems: "flex-end", // align to right
  },
  panel: {
    //flex: 1,
    //alignItems: "stretch",
    alignContent:"center",
    backgroundColor: "white",
    padding: 16,
    borderTopLeftRadius: 16,
    borderBottomLeftRadius: 16,

    borderWidth: 0.5, // Set the border width
    borderColor: 'gray', // Set the border color
    borderRadius: 5, // Set the border radius (optional)
    shadowColor: 'blue', // Set the shadow color
    shadowOffset: { width: 0, height: 2 }, // Set the shadow offset
    shadowOpacity: 0.5, // Set the shadow opacity
    shadowRadius: 4, // Set the shadow radius
    elevation: 4,
    //marginLeft: '5%',
    //marginRight: '5%',
    //paddingLeft: 5,
    //paddingRight: 5,
  },
});

export default RightPanel;